import { useSelector } from 'react-redux';
import { getActiveWorkspaceName } from '@/reducers/ui/workspaceUiReducer';

const useActiveWorkspaceName = (): string => {
  const activeWorkspaceName = useSelector(getActiveWorkspaceName);
  return activeWorkspaceName;
};

export default useActiveWorkspaceName;
